export default __webpack_public_path__ + "static/frontendDev-8451fe999ef221bca231bb1d627695aa.jpg";